import { inject, observer } from 'mobx-react';
import React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Instance } from 'mobx-state-tree';
import { TLCode } from '../../common/enums';
import styled from '@emotion/styled';
import {
  ApplicationStore,
  PharmacyStore,
  SecretariatNeighborStore,
  GroupStore,
  UserStore,
  UiStore,
  AuthenticationStore,
  SecretariatStore,
} from '../../store';
import PharmaciesMap from './PharmaciesMap';
import PharmaciesList from './PharmaciesList';
import { quickFilterFormatter } from '../../common/quickFilterFormatterUtils';
import { Pharmacy } from '../../store/models/Pharmacy';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

interface PharmaciesPageProps {
  PharmacyStore?: Instance<typeof PharmacyStore>;
  SecretariatNeighborStore?: Instance<typeof SecretariatNeighborStore>;
  GroupStore?: Instance<typeof GroupStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  UiStore?: Instance<typeof UiStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  UserStore?: Instance<typeof UserStore>;
}

interface PharmaciesPageState {
  isLoading: boolean;
  view: 'map' | 'grid';
  activeFilter: 'active' | 'inactive' | 'both';
  levelFilter: 'zero' | 'one' | 'three' | 'all';
  groupFilter: 'all';
  pharmaciesList: Array<Instance<typeof Pharmacy>>;
  data: any;
}

@inject('PharmacyStore', 'SecretariatNeighborStore', 'GroupStore')
@inject('ApplicationStore')
@inject('UiStore')
@inject('AuthenticationStore')
@inject('SecretariatStore')
@inject('UserStore')
@observer
class PharmaciesPage extends React.Component<PharmaciesPageProps, PharmaciesPageState> {
  state = {
    isLoading: false,
    view: 'grid',
    activeFilter: 'active',
    levelFilter: 'all',
  } as PharmaciesPageState;

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
    const { PharmacyStore, GroupStore, SecretariatNeighborStore } = this.props;
    this._isMounted && this.setState({ isLoading: true });
    await PharmacyStore!.checkListLoaded();
    
    let loadListToCall = [GroupStore!.checkListLoaded(), SecretariatNeighborStore!.checkListLoaded()];
    if (!PharmacyStore!.isListLoading()) loadListToCall = [PharmacyStore!.checkListLoaded() as any, ...loadListToCall];
    if (!PharmacyStore!.isListLoaded()) await Promise.all(loadListToCall);
    if (this.props.UiStore!.pharmaciesSecretariatIdFilter === 0) {
      this.props.UiStore!.setPharmaciesSecretariatIdFilter(this.getSelectedSecretariatId());
    } else {
      var secretariatId = this.getSelectedSecretariatId();
      this.props.UiStore!.setPharmaciesSecretariatIdFilter(secretariatId);
    }
    // Wait for Pharmacies list
    let maxWaitMs = 10000;
    let intervalMs = 100;
    let waited = 0;

    while (PharmacyStore!.isListLoading() && waited < maxWaitMs) {
      await new Promise((resolve) => setTimeout(resolve, intervalMs));
      waited += intervalMs;
    }

    // if (this.state.pharmaciesList === undefined) {
    //   this.setState({ pharmaciesList: this.props.PharmacyStore!.dataList });
    // }
    this._isMounted && this.setState({ isLoading: false });
  }

  
    // getEmail = (apbNumber: string) => {
    //   const user = this.props.UserStore!.dataList.find((user) => user.userName == apbNumber);
    //   return user ? user!.email! : '';
    // }
  
    // getPharmacyUser = (apbNumber: string) => {
    //   const user = this.props.UserStore!.dataList.find((user) => user.userName == apbNumber);
    //   return user ? user!.firstName! + ' ' + user!.lastName! : 'unknown';
    // }
  
    // buildGridData = () => {
    //   //const { activeFilter, levelFilter, secretariatFilter } = this.props;
    //   // const { statusFilter, levelFilter2 } = this.state;
    //   // if (this.props.AnchorStore.dataList.length == 0) {
    //   //   await this.props.AnchorStore!.loadList();
    //   // }
      
    //   //let statuses = this.props.PharmacyStatusStore!.dataList;
  
    //   //let activeStatus = statuses.find((s) => s.code == PHARMACY_STATUS_AC)!;
  
    //   var data = this.state.pharmaciesList
    //     .map((p) => ({
    //       pharmacyId: p.pharmacyId,
    //       apbNumber: p.apbNumber,
    //       name: p.name,
    //       phone: p.phone,
    //       address: p.address,
    //       zipCode: p.zipCode,
    //       city: p.city,
    //       level: p.level,
    //       statusId: p.statusId,
    //       statusName: p.status!.name,
    //       email: p.apbNumber ? this.getEmail(String(p.apbNumber)) : '',
    //       pharmacyUser: p.apbNumber ? this.getPharmacyUser(String(p.apbNumber)) : 'unknown',
    //       zone: p.zoneId,
    //       density: p.density,
    //       anchor: p.anchorName === undefined ? '' : p.anchorName.name, 
    //       group: p.group === undefined ? '' : p.group.name,
    //       secretariatId: p.secretariatId,
    //       secretariat: p.secretariat === undefined ? '': p.secretariat.code,
    //     }));
  
    //   return data;
    // };
  

  componentWillUnmount() {
    this._isMounted = false;
  }

  private getSelectedSecretariatId(): number | undefined {
    return this.props.AuthenticationStore!.isPharmacy &&
      this.props.SecretariatStore!.dataList.find(
        (s) =>
          s.secretariatId ===
          this.props.PharmacyStore!.dataList.find((p) => p.pharmacyId === this.props.AuthenticationStore!.pharmacyId)!
            .secretariatId,
      ) !== undefined
      ? this.props.PharmacyStore!.dataList.find((p) => p.pharmacyId === this.props.AuthenticationStore!.pharmacyId)!
        .secretariatId
      : this.props.AuthenticationStore!.isSecretariat && this.props.AuthenticationStore!.secretariatId
        ? this.props.AuthenticationStore!.secretariatId
        : this.props.SecretariatStore!.selectedSecretariatId;
  }

  loadPharmacyList = async () => {
    this._isMounted && this.setState({ isLoading: true });
    await this.props.PharmacyStore!.loadList();
    this._isMounted && this.setState({ isLoading: false });
  };

  quickFilterFormatter = (s) => {
    return quickFilterFormatter(s);
  };

  render() {
    const { view, isLoading } = this.state;
    const { PharmacyStore, GroupStore, ApplicationStore, UiStore } = this.props;
    const pharmaciesList = PharmacyStore!.dataList;
    const groupList = GroupStore!.dataList;
    const activeFilter = UiStore!.pharmaciesActiveFilter;
    const levelFilter = UiStore!.pharmaciesLevelFilter;
    const secretariatIdFilter = UiStore!.pharmaciesSecretariatIdFilter;
    return (
      <MainSectionLayout isLoading={isLoading} title={TLCode.PHARMACIES_Title}>
        <Container>
          {view === 'grid' ? (
            <PharmaciesList
              navigate={ApplicationStore!.navigate}
              pharmaciesList={pharmaciesList}
              showOnMap={() => this.setState({ view: 'map' })}
              activeFilter={activeFilter}
              levelFilter={levelFilter}
              secretariatFilter={secretariatIdFilter}
              setActiveFilter={(filter) => {
                this.setState({ activeFilter: filter });
                UiStore!.setPharmaciesActiveFilter(filter);
              }}
              setLevelFilter={(filter) => {
                this.setState({ levelFilter: filter });
                UiStore!.setPharmaciesLevelFilter(filter);
              }}
              setSecretariatFilter={(filter) => {
                UiStore!.setPharmaciesSecretariatIdFilter(filter);
              }}
              reloadPharmacyList={this.loadPharmacyList}
            />
          ) : (
            <PharmaciesMap
              isLoading={isLoading}
              onBackToList={() => this.setState({ view: 'grid' })}
              pharmaciesList={pharmaciesList}
              groupList={groupList}
            />
          )}
        </Container>
      </MainSectionLayout>
    );
  }
}

export default PharmaciesPage;
